<div class="checkout-page">

  <div class="checkout-container">

    <!-- =====================================================
         CARD PRINCIPAL
    ====================================================== -->

    <div class="checkout-card">

      <h1>
        Deixe sua estadia ainda melhor!
      </h1>

      <p class="subtitle">
        Escolha experiências e serviços adicionais para sua reserva
      </p>


      <!-- ===================================================
           CARREGANDO
      ==================================================== -->

      <div
        class="loading"
        *ngIf="carregando"
      >

        <div class="spinner"></div>

        <p>
          Carregando experiências...
        </p>

      </div>


      <!-- ===================================================
           PACOTES
      ==================================================== -->

      <div
        class="pacotes"
        *ngIf="!carregando"
      >

        <!-- SEM PACOTES -->

        <div
          class="sem-pacotes"
          *ngIf="pacotes.length === 0"
        >

          <div class="sem-pacotes-icon">
            ✨
          </div>

          <h2>
            Nenhum pacote disponível
          </h2>

          <p>
            No momento não há experiências adicionais
            disponíveis para esta acomodação.
          </p>

        </div>


        <!-- LISTA DE PACOTES -->

        <div
          class="pacotes-grid"
          *ngIf="pacotes.length > 0"
        >

          <div
            class="pacote-option"
            *ngFor="let pacote of pacotes"
            [class.selecionado]="estaSelecionado(pacote.id)"
            (click)="alternarPacote(pacote)"
          >

            <!-- IMAGEM -->

            <!-- ===================================================
     CARROSSEL DE IMAGENS
==================================================== -->

            <div class="pacote-imagem">

              <!-- IMAGEM -->

              <img
                *ngIf="getImagemAtual(pacote)"
                [src]="getImagemAtual(pacote)"
                [alt]="pacote.nome"
              />

              <!-- PLACEHOLDER -->

              <div
                class="imagem-placeholder"
                *ngIf="!getImagemAtual(pacote)"
              >
                ✨
              </div>


              <!-- SETA ANTERIOR -->

              <button
                type="button"
                class="carrossel-seta seta-anterior"

                *ngIf="
      pacote.imagens &&
      pacote.imagens.length > 1
    "

                (click)="imagemAnterior(pacote, $event)"

                aria-label="Imagem anterior"
              >
                ‹
              </button>


              <!-- SETA PRÓXIMA -->

              <button
                type="button"
                class="carrossel-seta seta-proxima"

                *ngIf="
      pacote.imagens &&
      pacote.imagens.length > 1
    "

                (click)="proximaImagem(pacote, $event)"

                aria-label="Próxima imagem"
              >
                ›
              </button>


              <!-- CONTADOR -->

              <div
                class="contador-imagens"

                *ngIf="
      pacote.imagens &&
      pacote.imagens.length > 1
    "
              >

                {{
                  (imagemAtualPorPacote[pacote.id] ?? 0) + 1
                }}

                /

                {{ pacote.imagens.length }}

              </div>


              <!-- INDICADORES -->

              <div
                class="indicadores-imagens"

                *ngIf="
      pacote.imagens &&
      pacote.imagens.length > 1
    "
              >

                <button
                  type="button"

                  class="indicador-imagem"

                  *ngFor="
        let imagem of pacote.imagens;
        let i = index
      "

                  [class.ativo]="
        (imagemAtualPorPacote[pacote.id] ?? 0) === i
      "

                  (click)="
        selecionarImagem(
          pacote,
          i,
          $event
        )
      "

                  [attr.aria-label]="
        'Ir para imagem ' + (i + 1)
      "
                >
                </button>

              </div>


              <!-- CHECK DE SELECIONADO -->

              <div
                class="check-selecionado"

                *ngIf="estaSelecionado(pacote.id)"
              >
                ✓
              </div>

            </div>


            <!-- CONTEÚDO -->

            <div class="pacote-conteudo">

              <h3>
                {{ pacote.nome }}
              </h3>

              <p
                class="pacote-descricao"
                *ngIf="pacote.descricao"
              >
                {{ pacote.descricao }}
              </p>


              <!-- ITENS INCLUSOS -->

              <div
                class="itens-inclusos"
                *ngIf="pacote.itensInclusos"
              >

                <strong>
                  Inclui
                </strong>

                <p>
                  {{ pacote.itensInclusos }}
                </p>

              </div>


              <!-- RODAPÉ DO PACOTE -->

              <div class="pacote-footer">

                <strong class="pacote-valor">
                  R$
                  {{ pacote.valor | number:'1.2-2' }}
                </strong>

                <button
                  type="button"
                  class="btn-adicionar"
                  [class.adicionado]="estaSelecionado(pacote.id)"
                  (click)="alternarPacote(pacote); $event.stopPropagation()"
                >

                  <ng-container
                    *ngIf="!estaSelecionado(pacote.id)"
                  >
                    + Adicionar
                  </ng-container>

                  <ng-container
                    *ngIf="estaSelecionado(pacote.id)"
                  >
                    ✓ Adicionado
                  </ng-container>

                </button>

              </div>

            </div>

          </div>

        </div>

      </div>


      <!-- ===================================================
           AÇÕES
      ==================================================== -->

      <div class="actions">

        <button
          type="button"
          class="btn-voltar"
          (click)="voltar()"
        >
          Voltar
        </button>

        <button
          type="button"
          class="btn-continuar"
          (click)="continuar()"
        >
          Continuar
        </button>

      </div>

    </div>


    <!-- =====================================================
         RESUMO DA RESERVA
         MESMO PADRÃO DA TELA DE HÓSPEDES
    ====================================================== -->

    <div class="resumo-card">

      <img
        [src]="dados?.quartoImagem"
        [alt]="dados?.quartoNome || 'Acomodação'"
      />

      <h3>
        {{ dados?.quartoNome || 'Acomodação' }}
      </h3>

      <p>
        {{ descricaoAcomodacao }}
      </p>


      <!-- CHECK-IN -->

      <div class="resumo-linha">

        <strong>
          Check-in
        </strong>

        <span>
          {{ formatarData(dados?.checkIn) }}
        </span>

      </div>


      <!-- CHECK-OUT -->

      <div class="resumo-linha">

        <strong>
          Check-out
        </strong>

        <span>
          {{ formatarData(dados?.checkOut) }}
        </span>

      </div>


      <!-- HÓSPEDES -->

      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>

          {{ adultos }}

          {{
            adultos === 1
              ? 'adulto'
              : 'adultos'
          }}

          <ng-container
            *ngIf="criancas > 0"
          >

            • {{ criancas }}

            {{
              criancas === 1
                ? 'criança'
                : 'crianças'
            }}

          </ng-container>

        </span>

      </div>


      <!-- ANIMAIS -->

      <div
        class="resumo-linha"
        *ngIf="animais > 0"
      >

        <strong>
          Animais
        </strong>

        <span>

          {{ animais }}

          {{
            animais === 1
              ? 'animal'
              : 'animais'
          }}

        </span>

      </div>


      <!-- NOITES -->

      <div class="resumo-linha">

        <strong>
          Noites
        </strong>

        <span>
          {{ quantidadeNoites }}
        </span>

      </div>


      <!-- HOSPEDAGEM -->

      <div class="resumo-linha">

        <strong>
          Hospedagem
        </strong>

        <span>
          R$ {{ valorHospedagem | number:'1.2-2' }}
        </span>

      </div>


      <!-- PACOTES -->

      <div
        class="resumo-linha"
        *ngIf="valorPacotes > 0"
      >

        <strong>
          Pacotes
        </strong>

        <span>
          R$ {{ valorPacotes | number:'1.2-2' }}
        </span>

      </div>


      <!-- PACOTES SELECIONADOS -->

      <div
        class="pacotes-resumo"
        *ngIf="pacotesSelecionados.length > 0"
      >

        <div
          class="pacote-resumo"
          *ngFor="let pacote of pacotesSelecionados"
        >

          <span>
            {{ pacote.nome }}
          </span>

          <strong>
            R$ {{ pacote.valor | number:'1.2-2' }}
          </strong>

        </div>

      </div>


      <!-- TOTAL -->

      <div class="resumo-linha total">

        <strong>
          Preço total
        </strong>

        <span>
          R$ {{ valorTotalComPacotes | number:'1.2-2' }}
        </span>

      </div>

    </div>

  </div>

</div>
